import LoginIcon from '@mui/icons-material/Login';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Image from 'next/image';
import * as React from 'react';
import { useMemo } from 'react';
import { Images } from '../assets';
import { ContentData } from '../interface';
import { useAccessToken } from '../providers/AccessTokenProvider';
import ClaimContainer from './ClaimContainer';
import SecurityContainer from './SecurityContainer';

export interface WalletOptionsProps {
  enableMetamask: boolean;
  enableWalletConnect: boolean;
  enableCrossmint: boolean;
  enableEmailWallet: boolean;
}

export interface ConnectWalletProps {
  walletOptions: WalletOptionsProps;
  logoUrl?: string;
  content?: ContentData;
  onClickDoNotHaveWallet: () => void;
  onClickMetamask: () => void;
  onClickWalletConnect: () => void;
}

const ConnectExistingWalletContainer = ({
  walletOptions,
  onClickDoNotHaveWallet,
  content,
  onClickMetamask,
  onClickWalletConnect
}: ConnectWalletProps) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  const { accessToken } = useAccessToken();
  const walletButtonStyle = useMemo(() => {
    return {
      width: '100%'
    };
  }, []);

  return (
    <Box>
      <ClaimContainer
        title={!accessToken ? 'Are you a person?' : content?.title || 'Connect your wallet'}
        description={
          !accessToken
            ? "We apologize for the confusion and please don't take that question personally. Please check the box to verify that you are not a bot."
            : content?.description
        }
      />
      {accessToken ? (
        <>
          {walletOptions.enableMetamask && !isMobileOrTablet && (
            <Button
              sx={{
                ...walletButtonStyle,
                marginBottom: '16px'
              }}
              startIcon={<Image src={Images.METAMASK} width={16} height={16} alt="metamask" />}
              onClick={onClickMetamask}
            >
              MetaMask
            </Button>
          )}
          {walletOptions.enableWalletConnect && (
            <Button
              sx={{
                ...walletButtonStyle,
                marginBottom: '16px'
              }}
              startIcon={<Image src={Images.WALLET_CONNECT} width={16} height={16} alt="wallet-connect" />}
              onClick={onClickWalletConnect}
            >
              WalletConnect
            </Button>
          )}
          {walletOptions?.enableEmailWallet && (
            <Button
              sx={{
                ...walletButtonStyle
              }}
              startIcon={
                <LoginIcon
                  sx={{
                    color: theme.palette.background.default,
                    fontSize: '0.8rem'
                  }}
                />
              }
              onClick={onClickDoNotHaveWallet}
            >
              Create wallet with email or social
            </Button>
          )}
        </>
      ) : (
        <SecurityContainer />
      )}
    </Box>
  );
};

export default ConnectExistingWalletContainer;
